var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 48,
    viewBox: "0 0 38 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.6568 41.5003C32.7201 44.3937 30.6668 47.217 27.5401 47.2637C24.4135 47.3337 23.4101 45.4203 19.8635 45.4203C16.2935 45.4203 15.1968 47.217 12.2335 47.3337C9.1768 47.4503 6.8668 44.2537 4.9068 41.4303C0.9168 35.667 -2.13987 25.0503 1.9668 17.9103C3.9968 14.3637 7.6368 12.1237 11.5801 12.0537C14.5668 12.007 17.4135 14.0837 19.2568 14.0837C21.0768 14.0837 24.5301 11.587 28.1468 11.9603C29.6635 12.0303 33.9101 12.567 36.6401 16.5803C36.4301 16.7203 31.5768 19.567 31.6235 25.4703C31.6935 32.517 37.8068 34.8737 37.8768 34.897C37.8068 35.0603 36.8968 38.257 34.6568 41.5003ZM21.3335 4.16699C23.0368 2.23033 25.8601 0.760326 28.1935 0.666992C28.4968 3.39699 27.4001 6.15033 25.7668 8.11033C24.1568 10.0937 21.4968 11.6337 18.8835 11.4237C18.5335 8.74033 19.8401 5.94033 21.3335 4.16699Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.04b069bcc9ab4ae0654c716f1dfeb106.svg";
export { ForwardRef as ReactComponent };